/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1667
 */

var r = require(/* 86 */"./1650/86/index")
var o = require(/* 168 */"./1648/168")
var i = require(/* 441 */"./1718/441")
var /* [auto-meaningful-name] */require_386_$_1648_386$f = require(/* 386 */"./1648/386").f
var s = require(/* 271 */"./1648/271")
var c = o(function () {
  require_386_$_1648_386$f(1)
})
r({
  target: "Object",
  stat: true,
  forced: !s || c,
  sham: !s
}, {
  getOwnPropertyDescriptor: function (e, t) {
    return require_386_$_1648_386$f(i(e), t)
  }
})
